import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_name: "", contact_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created!");
      navigate("/dashboard");
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <div className="label-tag">Manufacturer Sign Up</div>
      <h1 className="font-heading text-4xl md:text-5xl font-black uppercase mt-2 leading-none text-[#1A365D]">
        Join the network.
      </h1>
      <p className="mt-2 text-slate-600">Get lead accountability across your dealer network. See every opportunity you generate — from click to close.</p>

      <form onSubmit={submit} className="brutal-card p-8 mt-8 space-y-5">
        <div>
          <label className="label-tag block mb-2">Company Name</label>
          <input required value={form.company_name} onChange={(e) => update("company_name", e.target.value)} className="ll-input" data-testid="register-company-input"/>
        </div>
        <div>
          <label className="label-tag block mb-2">Your Name</label>
          <input required value={form.contact_name} onChange={(e) => update("contact_name", e.target.value)} className="ll-input" data-testid="register-name-input"/>
        </div>
        <div>
          <label className="label-tag block mb-2">Email</label>
          <input type="email" required value={form.email} onChange={(e) => update("email", e.target.value)} className="ll-input" data-testid="register-email-input"/>
        </div>
        <div>
          <label className="label-tag block mb-2">Password (min 6 chars)</label>
          <input type="password" required minLength={6} value={form.password} onChange={(e) => update("password", e.target.value)} className="ll-input" data-testid="register-password-input"/>
        </div>
        <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="register-submit-btn">
          {loading ? "Creating…" : "Create Account"}
        </button>
        <div className="text-sm text-slate-600 text-center">
          Already registered? <Link to="/login" className="font-bold text-[#C62828] hover:underline" data-testid="register-to-login-link">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
